import { api } from './api';

export type CalendarEventItem = {
  id: number;
  title: string;
  description?: string | null;
  event_type?: string | null;
  created_by_id?: number | null;
  created_by?: { id: number; full_name?: string | null; email?: string | null; role?: string | null } | null;
  start_time: string; // ISO
  end_time: string; // ISO
  invited_classes?: Array<{ id: number; name: string }>;
  invite_label?: string | null;
  participants?: Array<{
    user_id: number;
    role: string;
    approved: boolean;
    response?: 'pending' | 'accepted' | 'declined' | string | null;
    reminder_minutes?: number | null;
    full_name?: string | null;
    email?: string | null;
  }>;
};

export type CalendarCreatePayload = {
  title: string;
  description?: string | null;
  event_type?: string | null;
  start_time: string; // ISO
  end_time: string; // ISO
  reminder_minutes?: number | null;

  invited_classroom_id?: number | null;
  invite_parents_of_class?: boolean;
  invite_all_teachers?: boolean;
  invited_user_ids?: number[] | null;
};

export type CalendarUserOption = {
  id: number;
  full_name: string;
  email: string;
  role: string;
  classroom_id?: number | null;
  school_id?: number | null;
  school_name?: string | null;
  is_platform_admin?: boolean;
};

export async function fetchCalendarEvents(params?: { start?: string; end?: string }): Promise<CalendarEventItem[]> {
  const resp = await api.get('/api/calendar/events', { params });
  return Array.isArray(resp.data) ? (resp.data as CalendarEventItem[]) : [];
}

export async function fetchUpcomingEvents(limit = 5): Promise<CalendarEventItem[]> {
  const resp = await api.get('/api/calendar/events/upcoming', { params: { limit } });
  return Array.isArray(resp.data) ? (resp.data as CalendarEventItem[]) : [];
}

export async function createCalendarEvent(payload: CalendarCreatePayload): Promise<CalendarEventItem> {
  const resp = await api.post('/api/calendar/events', payload);
  return resp.data as CalendarEventItem;
}

export async function addCalendarInvites(eventId: number, payload: CalendarCreatePayload): Promise<{ added: number }> {
  const resp = await api.post(`/api/calendar/events/${eventId}/invites`, payload);
  return resp.data as { added: number };
}

export async function cancelCalendarEvent(eventId: number): Promise<void> {
  await api.delete(`/api/calendar/events/${eventId}`);
}

export async function searchCalendarUsers(params: { q: string; role?: string | null; limit?: number }): Promise<CalendarUserOption[]> {
  const resp = await api.get('/api/calendar/users', { params });
  return Array.isArray(resp.data) ? (resp.data as CalendarUserOption[]) : [];
}

export async function approveCalendarInvite(eventId: number): Promise<void> {
  await api.put(`/api/calendar/events/${eventId}/me/approve`, {});
}

export async function declineCalendarInvite(eventId: number): Promise<void> {
  await api.put(`/api/calendar/events/${eventId}/me/decline`, {});
}
